const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const formatPrice = (price) => {
  if (!price) return '-';
  return new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(Math.round(price));
};

export const formatGoldPrice = (price) => {
  if (!price) return '-';
  const hasDecimal = price % 1 !== 0;
  const formatted = new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: hasDecimal ? 1 : 0,
    maximumFractionDigits: 2
  }).format(price);
  return formatted.replace(',', '.');
};
